import { render } from "./lidaPage1.vue?vue&type=template&id=318dafe4"
import script from "./lidaPage1.vue?vue&type=script&lang=js"
export * from "./lidaPage1.vue?vue&type=script&lang=js"

import "./lidaPage1.vue?vue&type=style&index=0&id=318dafe4&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__